<div
  class="d-flex align-items-center"
  [attr.aria-label]="
    course.name +
    ',' +
    (course.instructorNames
      ? ' Instructor name is ' + course.instructorNames + (course.courseCode ? ' and' : '')
      : '') +
    (course.courseCode ? ' course code is ' + course.courseCode : '') +
    '.'
  "
>
  <button
    class="pmd-avatar pmd-avatar-secondary me-3 course-icon-container"
    tabindex="0"
    [routerLink]="['/course', course.id, 'game']"
  >
    <!-- aria-hidden="true" -->
    <img
      *ngIf="course.icon"
      class="course-icon"
      [src]="course.icon"
      [alt]="course.name"
      width="40"
      height="40"
    />
    <span *ngIf="!course.icon && course.courseCode">
      {{ course.courseCode.substring(0, 2) }}
    </span>
  </button>
  <div class="flex-grow-1">
    <a class="pb-link h6 course-name" [routerLink]="['/course', course.id, 'game']" tabindex="0">
      {{ course.name }}
    </a>
    <p class="mb-0 card-subtitle" *ngIf="course.instructorNames">
      Instructors: {{ course.instructorNames }}
    </p>
    <p class="mb-0 card-subtitle" *ngIf="course.courseCode">Code: {{ course.courseCode }}</p>
  </div>
</div>
